const getShortUrl = () => {
  const url = window.location.href
  const splittedUrl = url.split('/');
  const formattedUrl = `${splittedUrl[0]} //${splittedUrl[2]}/${splittedUrl[3]}`
  return formattedUrl
};

export const bodyBrowser = {
  BinConfigIdentifiers: null,
  Cookies: {
    Legacy: true,
    LocalStorage: true,
    SessionStorage: true
  },
  DeviceChannel: "Browser",
  Extended: {
    Browser: {
      Adblock: true,
      AvailableJsFonts: [],
      DoNotTrack: "unknown",
      JavaEnabled: false
    },
    Device: {
      ColorDepth: 24,
      Cpu: "unknown",
      Platform: "Win32",
      TouchSupport: {
        MaxTouchPoints: 0,
        OnTouchStartAvailable: false,
        TouchEventCreationSuccessful: false
      }
    }
  },
  Fingerprint: "8a39636883ba024677d3931411ef5053",
  FingerprintingTime: 136,
  FingerprintDetails: {
    Version: "1.5.1"
  },
  Language: "pt-BR",
  Latitude: null,
  Longitude: null,
  OrgUnitId: "609958bb0d61937ce23889fb",
  Origin: "Songbird",
  Plugins: [
    "PDFViewe:Portable DocumentForma:application/pdf~pdf,text/pdf~pdf",
    "Chrome PDFViewe:Portable DocumentForma:application/pdf~pdf,text/pdf~pdf",
    "Chromium PDFViewe:Portable DocumentForma:application/pdf~pdf,text/pdf~pdf",
    "Microsoft Edge PDFViewe:Portable DocumentForma:application/pdf~pdf,text/pdf~pdf",
    "WebKit built-inPD:Portable DocumentForma:application/pdf~pdf,text/pdf~pdf"
  ],
  ReferenceId: "bc0fb795-cf54-46e3-881b-04f7863909dc",
  Referrer: getShortUrl(),
  Screen: {
    FakedResolution: false,
    Ratio: 1.7786458333333333,
    Resolution: "1366x768",
    UsableResolution: "1366x768",
    CCAScreenSize: "02"
  },
  CallSignEnabled: null,
  ThreatMetrixEnabled: "false",
  ThreatMetrixEventType: "PAYMENT",
  ThreatMetrixAlias: "Default",
  TimeOffset: 180,
  UserAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/107.0.0.0 Safari/537.36 OPR/93.0.0.0",
  UserAgentDetails: {
    FakedOS: false,
    FakedBrowser: false
  },
  BinSessionId: null
}

export const bodyLog = {
  mutator: "EndpointMonitor",
  application: "Endpoint Monitor",
  data: [
    {
      clientId: "AutoGenerated-47091195-1c26-4d30-80d7-176f07a04d54",
      action: "https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js",
      runTime: 3.8000000715255737,
      wasSuccessful: false,
      location: "/index.html",
      millisFromLoad: 309.09999990463257
    },
    {
      clientId: "AutoGenerated-2ddf1951-e619-42fc-99ea-1b7f01850a6b",
      action: "https://songbirdstag.cardinalcommerce.com/edge/v1/a960453caa80548c4a43/5.a960453caa80548c4a43.songbird.js",
      runTime: 9.5,
      wasSuccessful: false,
      location: "/index.html",
      millisFromLoad: 374.1999999284744
    },
    {
      clientId: "jti-d08abe40-7fdd-4106-9836-c3969701e9e9",
      action: "https://songbirdstag.cardinalcommerce.com/edge/v1/a960453caa80548c4a43/10.a960453caa80548c4a43.songbird.js",
      runTime: 2.5,
      wasSuccessful: false,
      location: "/index.html",
      millisFromLoad: 1269.3999999761581
    },
    {
      clientId: "jti-d08abe40-7fdd-4106-9836-c3969701e9e9",
      action: "https://centinelapistag.cardinalcommerce.com/V1/Order/JWT/Init",
      runTime: 693.1000000238419,
      wasSuccessful: true,
      location: "/index.html",
      millisFromLoad: 1279.3999999761581
    },
    {
      clientId: "mcsId-1_5adb4703-0f10-4f23-9f0a-cc967f265dc0",
      action: "https://songbirdstag.cardinalcommerce.com/edge/v1/a960453caa80548c4a43/11.a960453caa80548c4a43.songbird.js",
      runTime: 3,
      wasSuccessful: false,
      location: "/index.html",
      millisFromLoad: 1978.7999999523163
    },
    {
      clientId: "mcsId-1_5adb4703-0f10-4f23-9f0a-cc967f265dc0",
      action: "https://songbirdstag.cardinalcommerce.com/edge/v1/a960453caa80548c4a43/8.a960453caa80548c4a43.songbird.js",
      runTime: 15.700000047683716,
      wasSuccessful: false,
      location: "/index.html",
      millisFromLoad: 1985.6999999284744
    },
    {
      clientId: "mcsId-1_5adb4703-0f10-4f23-9f0a-cc967f265dc0",
      action: "https://geostag.cardinalcommerce.com/DeviceFingerprintWeb/V2/Browser/Render?threatmetrix=true&alias=Default&orgUnitId=609958bb0d61937ce23889fb&tmEventType=PAYMENT&referenceId=bc0fb795-cf54-46e3-881b-04f7863909dc&geolocation=false&origin=Songbird",
      runTime: 585.7000000476837,
      wasSuccessful: false,
      location: "/index.html",
      millisFromLoad: 1982.2999999523163
    }
  ]
}